import { MatrizIdentidadTiposCuestionariosProductos } from './../_models/matriz-identidad-tipos-cuestionarios-productos';
import { AutenticacionService } from './autenticacion.service';
import { AppSettings } from './../../proyect.conf';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MatrizIdentidadTiposCuestionariosProductosService {
  
  private rutServicio = AppSettings.rutServiciosAPL + '/api/matrizIdentidadTiposCuestionariosProductos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as MatrizIdentidadTiposCuestionariosProductos[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as MatrizIdentidadTiposCuestionariosProductos[] ) );
  }

  listadoPorIdMatrizIdentidad(idMatrizIdentidad: string) {
    return this.httClient.get( this.rutServicio + '/matrizIdentidad/' +  idMatrizIdentidad).pipe( map( res => res as MatrizIdentidadTiposCuestionariosProductos[] ) );
  }

  listadoPorIdMatrizIdentidadHabilitados(idMatrizIdentidad: string) {
    return this.httClient.get( this.rutServicio + '/matrizIdentidad/' +  idMatrizIdentidad + '/enabled').pipe( map( res => res as MatrizIdentidadTiposCuestionariosProductos[] ) );
  }
  
  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as MatrizIdentidadTiposCuestionariosProductos ) );
  }

  crear( regCrear: MatrizIdentidadTiposCuestionariosProductos ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as MatrizIdentidadTiposCuestionariosProductos ) );
  }

  actualizar( regActualizar: MatrizIdentidadTiposCuestionariosProductos ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( matrizIdentidad: MatrizIdentidadTiposCuestionariosProductos[] ): Observable<MatrizIdentidadTiposCuestionariosProductos[]> {
    matrizIdentidad.map( sa => {
      sa.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', matrizIdentidad ).pipe( map( res => res as MatrizIdentidadTiposCuestionariosProductos[] ) );
  }
}
